if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span.button-text span');
        this.preProp = this.querySelector('.pre-prop');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (!this.classList.contains('shop-card-form')) {
                this.cart.renderContents(response);
              } else {
                if (document.querySelector('[data-box-collection]')) {
                  var sectionId = document.querySelector('[data-box-collection]').getAttribute('data-section');
                  fetchSection(sectionId)
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.submitButton.classList.contains('quick-add__submit')) {
              this.submitButton.closest('[data-card]').querySelectorAll('[data-option] a').forEach((a) => {
                if (a.parentElement.getAttribute('data-size') == 'yes') {
                  a.classList.remove('current');
                  // a.classList.remove('disabled');
                }
              });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      
      toggleSubmitButton(disable = true, text, variant_id) {
        this.submitButton.style.display = "flex";
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.preProp.setAttribute('disabled', 'disabled');
          if (text) {
             if (notify_button[variant_id] == 'true') {
              this.submitButton.removeAttribute('disabled');
              this.submitButton.classList.add('klaviyo-bis-trigger');
              this.submitButtonText.textContent = window.variantStrings.notifyButton;
              this.submitButtonText.parentElement.setAttribute('data-text', window.variantStrings.notifyButton);
            } else {
              this.submitButton.classList.remove('klaviyo-bis-trigger');
              this.submitButtonText.textContent = text;
              this.submitButtonText.parentElement.setAttribute('data-text', text);
            }
          }
        } else {
          if (notify_button[variant_id] == 'true') {
            this.submitButton.removeAttribute('disabled');
            this.preProp.setAttribute('disabled', 'disabled');
            this.submitButton.classList.add('klaviyo-bis-trigger');
            this.submitButtonText.textContent = window.variantStrings.notifyButton;
            this.submitButtonText.parentElement.setAttribute('data-text', window.variantStrings.notifyButton);
          } else {
            if (varInvMng[variant_id] == 'shopify' && varInvPlcy[variant_id] == 'continue' && varInvQty[variant_id] <= 0 && preorder_button[variant_id] == 'true' ) {
              this.submitButton.removeAttribute('disabled');
              this.preProp.removeAttribute('disabled');
              this.submitButton.classList.remove('klaviyo-bis-trigger');
              this.submitButtonText.textContent = window.variantStrings.preOrder;
              this.submitButtonText.parentElement.setAttribute('data-text', window.variantStrings.preOrder);
            } else {
              this.submitButton.classList.remove('klaviyo-bis-trigger');
              this.submitButton.removeAttribute('disabled');
              this.preProp.setAttribute('disabled', 'disabled');
              this.submitButtonText.textContent = window.variantStrings.addToCart;
              this.submitButtonText.parentElement.setAttribute('data-text', window.variantStrings.addToCart);
            }
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}